
import { Component, Vue } from 'nuxt-property-decorator'
import { Context } from '@nuxt/types'
import AppTopItem from '~/components/AppTopItem.vue'
import { ItemModel } from '~/types/ItemModel'
import { Painting } from '~/types/dto/Painting'
import FullScreenImage from '~/components/index/FullScreenImage.vue'
import AmpAppTopItem from '~/components/amp/AmpAppTopItem.vue'
import BuyPainting from '~/components/buy/BuyPainting.vue'

@Component({
  // @ts-ignore
  amp: 'hybrid',
  ampLayout: 'amp',
  components: { BuyPainting, AmpAppTopItem, FullScreenImage, AppTopItem }
})
export default class extends Vue {
  upperBlock!: ItemModel[]
  middleBlock!: ItemModel[]
  lowerBlock!: ItemModel[]
  component: any = this.$isAMP ? AmpAppTopItem : AppTopItem
  painting: any = {}
  isShowBuyPainting: boolean = false

  head () {
    return {
      title: this.$t('head.title.top-paintings'),
      meta: [
        { hid: 'description', name: 'description', content: this.$t('head.description.top-paintings') },
        { hid: 'og:title', name: 'og:title', content: this.$t('head.title.top-paintings') },
        { hid: 'og:description', name: 'og:description', content: this.$t('head.description.top-paintings') },
        { hid: 'og:image', name: 'og:image', content: require('~/assets/img/logo-black.svg') },
        { hid: 'og:type', name: 'og:type', content: 'website' },
        { hid: 'og:url', name: 'og:url', content: process.env.API_ENDPOINT + this.$route.fullPath }
      ]
    }
  }

  async asyncData (context: Context) {
    const artist: Painting[] = await context.$axios.get(
      process.env.API_ENDPOINT + '/api/v3/paintings/top',
      {
        // @ts-ignore
        cache: true,
        // @ts-ignore
        requireToken: false
      }
    ).then(response => response.data)

    const upperBlock = [{ number: 1, item: artist[0] }]
    const middleBlock = artist.slice(1, 4).map((item, index) => ({
      number: index + 2,
      item
    }))
    const lowerBlock = artist.slice(4).map((item, index) => ({
      number: index + 5,
      item
    }))

    return {
      upperBlock,
      middleBlock,
      lowerBlock
    }
  }

  mounted () {
    this.$eventBus.$on('painting', (painting) => {
      this.painting = painting
      this.isShowBuyPainting = Boolean(painting)
    })
  }
}
